import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `FetchToken`, method: 'GET'})
}
